export default __webpack_public_path__ + "static/media/sad.9f5c229e.svg";